export const ART_EVENT_ID_LOCAL_STORAGE_KEY = 'selectedArtEventId';
